import { RootState } from '@store/redux/store';

export function selectStudio() {
  return (reduxState: RootState) => {
    return reduxState.auth.studioId;
  };
}
